import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';

import AddReview from '@features/supplier/component/AddReview';

import { getSuppliersDetails, getSuppliersReviews, getSuppliersReviewSummaries } from '@store/reducers';
import { fetchSupplierReviews, fetchSupplierReviewSummaries } from '@store/supplier/action';

import { getUserInfo } from '@utils/Util';

const RatingAndReview = ({ isAdd, onSetAdd }) => {
	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(3);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedItem, setSelecteItem] = useState(null);
	const [isShowRating, setIsShowRating] = useState(isAdd);
	const [userDetails, setUserDetails] = useState(null);
	const [viewType, setViewType] = useState('');

	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		setIsShowRating(isAdd);
		setViewType(isAdd ? 'add' : '');
	}, [isAdd]);

	useEffect(() => {
		const userInfo = getUserInfo();
		setUserDetails(userInfo);
		dispatch(fetchSupplierReviewSummaries(id)).finally(() => {
			setIsLoading(false);
		});
	}, [dispatch, id]);

	useEffect(() => {
		dispatch(fetchSupplierReviews(id, page, pageSize)).finally(() => {
			setIsLoading(false);
		});
	}, [dispatch, id, pageSize, page]);

	const onRatingSuccess = () => {
		setIsLoading(true);
		dispatch(fetchSupplierReviewSummaries(id)).then(() => {
			dispatch(fetchSupplierReviews(id, page, pageSize)).finally(() => {
				setIsLoading(false);
			});
		});
	};

	const suppliersReviewSummaries = useSelector(getSuppliersReviewSummaries);
	const usersReview = useSelector(getSuppliersReviews);
	const supplierDetails = useSelector(getSuppliersDetails);

	const communicationRating = suppliersReviewSummaries?.averageCommunicationRating;
	const onTimeDeliveryRating = suppliersReviewSummaries?.averageOnTimeDeliveryRating;
	const experienceRating = suppliersReviewSummaries?.averageExperienceRating;

	const onViewMore = () => {
		setIsLoading(true);
		const currentPage = usersReview.currentPage;
		const totalPages = usersReview.totalPages;
		if (currentPage < totalPages - 1) {
			setPage((page) => page + 1);
			setPageSize(3);
		}
	};
	const renderReview = (rating) => {
		const isIntNumber = Number.isInteger(rating);

		if (isIntNumber) {
			return [...Array(5)].map((item, idx) => {
				if (idx < rating) {
					return (
						<img key={idx} src={`${process.env.PUBLIC_URL}/icons/star-filled.svg`} alt="star" />
					);
				} else {
					return (
						<img key={idx} src={`${process.env.PUBLIC_URL}/icons/star-default.svg`} alt="star" />
					);
				}
			});
		} else {
			let number = Math.floor(rating);
			return [...Array(5)].map((item, idx) => {
				if (idx < number) {
					return (
						<img key={idx} src={`${process.env.PUBLIC_URL}/icons/star-filled.svg`} alt="star" />
					);
				} else if (idx === number) {
					return (
						<img
							key={idx}
							src={`${process.env.PUBLIC_URL}/icons/star-half-filled.png`}
							alt="star"
						/>
					);
				} else {
					return (
						<img key={idx} src={`${process.env.PUBLIC_URL}/icons/star-default.svg`} alt="star" />
					);
				}
			});
		}
	};

	const onEditRating = (item) => {
		setIsShowRating(true);
		setSelecteItem(item);
		setViewType('edit');
	};
	const handleClose = () => {
		onSetAdd();
		setIsShowRating(false);
		setSelecteItem(null);
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="row" id="rating-review-section">
				<div className="col-sm-12 col-md-6 col-lg-4 padding-col">
					<div className="rating-avarage">
						<div className="rating-title d-flex justify-content-between align-items-center">
							<div className="rating-score">
								<span className="semibold-16 rating-value">
									{renderReview(supplierDetails?.ratingValue)}
								</span>
							</div>
							<div className="rating-count">
								<p className="regular-16 weight-600 gray_dark_02">
									{usersReview?.totalElements} Reviews
								</p>
							</div>
						</div>
						<div className="rating-details">
							<div className="single-one py-1 d-flex justify-content-between align-items-center">
								<p className="regular-16 gray_dark_02">Communication</p>
								<span className="star-review rating-3-half">
									{renderReview(communicationRating)}
								</span>
							</div>

							<div className="single-one py-1 d-flex justify-content-between align-items-center">
								<p className="regular-16 gray_dark_02">Support</p>
								<span className="star-review rating-3-half">
									{renderReview(experienceRating)}
								</span>
							</div>

							<div className="single-one py-1 d-flex justify-content-between align-items-center">
								<p className="regular-16 gray_dark_02">Transparency</p>
								<span className="star-review rating-2-half">
									{renderReview(onTimeDeliveryRating)}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-12 col-md-6 col-lg-8">
					<div className="right-half">
						<div className="all-commnets">
							{usersReview.data?.map((item, idx) => (
								<div className="single-comment" key={idx}>
									<div className="profile-photo">
										{!item?.addedBy?.profilePicDocument ? (
											<span className="regular-16 white rounded-circle">
												{item?.addedBy?.profilePicDocument?.name
													?.charAt(0)
													.toUpperCase()}
											</span>
										) : (
											<img
												src={item?.addedBy?.profilePicDocument?.docUrl}
												alt="profile"
											/>
										)}
									</div>
									<div className="name-designation">
										<h3 className="regular-14 gray_dark_01">
											{item?.addedBy?.name}{' '}
											<span className="tag gray_dark_01 regular-12 ml-1">
												{item?.addedBy?.designation}
											</span>
											{userDetails?.id === item?.addedBy?.id && (
												<img
													src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
													alt="edit"
													onClick={() => onEditRating(item)}
												/>
											)}
										</h3>
									</div>

									<div className="rating-details">
										<span className="star-review rating-4">
											{renderReview(item?.averageRatingValue)}
										</span>
									</div>
									<div className="rating-comment">
										<p className="regular-14">{item?.remarks}</p>
									</div>
								</div>
							))}
						</div>
					</div>
					{usersReview?.totalElements > pageSize && usersReview?.totalPages - page > 1 && (
						<div className="view-more-btn size32">
							<button className="button text">
								<span className="mr-1" onClick={() => onViewMore()}>
									View more
								</span>
								<img src={`${process.env.PUBLIC_URL}/icons/Down-arrow-primary.svg`} alt="" />
							</button>
						</div>
					)}
				</div>
			</div>

			{isShowRating && (
				<AddReview
					viewType={viewType}
					onSuccess={() => {
						onRatingSuccess();
						handleClose();
					}}
					onCloseReview={handleClose}
					supplierDetails={{
						supplierName: supplierDetails?.name,
						supplierId: supplierDetails?.id
					}}
					selectedData={selectedItem}
				/>
			)}
		</LoaderComponent>
	);
};

export default RatingAndReview;
